import { useRef, useState } from "react";
import { api } from "@/lib/api";
import { Upload, Image as ImageIcon, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ImageUploadInput({ value, onChange, purpose = "image", label = "Image" }) {
    const [loading, setLoading] = useState(false);
    const inputRef = useRef(null);
    const BACKEND = process.env.REACT_APP_BACKEND_URL;

    async function handleUpload(e) {
        const file = e.target.files?.[0];
        if (!file) return;
        setLoading(true);
        try {
            const fd = new FormData();
            fd.append("file", file);
            fd.append("purpose", purpose);
            const { data } = await api.post("/upload", fd, {
                headers: { "Content-Type": "multipart/form-data" },
            });
            const fullUrl = `${BACKEND}${data.url}`;
            onChange(fullUrl);
            toast.success("Uploaded!");
        } catch (err) {
            toast.error("Upload failed");
        } finally {
            setLoading(false);
            if (inputRef.current) inputRef.current.value = "";
        }
    }

    return (
        <div className="border border-border p-3" data-testid="image-upload-input">
            <div className="text-xs text-muted-foreground mb-2">{label}</div>
            <div className="flex gap-3 items-start">
                <div className="w-20 h-20 bg-surface border border-border overflow-hidden flex items-center justify-center shrink-0">
                    {value ? (
                        <img src={value} alt="" className="w-full h-full object-cover" />
                    ) : (
                        <ImageIcon className="w-6 h-6 text-muted-foreground" />
                    )}
                </div>
                <div className="flex-1 space-y-2">
                    <input
                        type="text"
                        value={value}
                        onChange={(e) => onChange(e.target.value)}
                        placeholder="Paste URL or upload below"
                        className="w-full border border-border px-3 py-1.5 text-xs focus:outline-none focus:border-primary"
                        data-testid="image-url-input"
                    />
                    <button
                        type="button"
                        onClick={() => inputRef.current?.click()}
                        disabled={loading}
                        className="text-xs inline-flex items-center gap-1.5 px-3 py-1.5 bg-primary text-white hover:bg-primary-hover disabled:opacity-50"
                        data-testid="image-upload-trigger"
                    >
                        {loading ? <Loader2 className="w-3 h-3 animate-spin" /> : <Upload className="w-3 h-3" />}
                        {loading ? "Uploading…" : "Upload file"}
                    </button>
                    <input
                        ref={inputRef}
                        type="file"
                        accept="image/*"
                        onChange={handleUpload}
                        className="hidden"
                    />
                </div>
            </div>
        </div>
    );
}
